import {
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILED,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILED,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  FETCH_ALL_USERS_STATIC,
  FETCH_ALL_USERS_STATIC_SUCCESS,
  FETCH_ALL_USERS_STATIC_FAILED,
  USER_DELETED,
  FETCH_ALL_DRIVERS,
  FETCH_ALL_DRIVERS_SUCCESS,
  FETCH_ALL_DRIVERS_FAILED
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, set, push, update, off, get, remove } from "firebase/database";
import { uploadBytesResumable } from "firebase/storage";
import { signOut } from "firebase/auth";
import store from '../store/store';

export const fetchUsers = () => (dispatch) => {

  const {
    usersRef,
    allLocationsRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_USERS,
    payload: null
  });
  onValue(usersRef, async snapshot => {
    if (snapshot.val()) {
      const locationdata = await get(allLocationsRef);
      const locations = locationdata.val();
      const data = snapshot.val();
      const arr = Object.keys(data)
      .filter(i => data[i].usertype!='admin')
      .map(i => {
        data[i].id = i;
        data[i].location = locations && locations[i] ? locations[i] : null;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_ALL_USERS_FAILED,
        payload: "No users available."
      });
    }
  });
};


export const fetchUsersOnce = () => (dispatch) => {

  const {
    usersRef,
    allLocationsRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_USERS_STATIC,
    payload: null
  });
  onValue(usersRef, async snapshot => {
    if (snapshot.val()) {
      const locationdata = await get(allLocationsRef);
      const locations = locationdata.val();
      const data = snapshot.val();
      const arr = Object.keys(data)
      .map(i => {
        data[i].id = i;
        data[i].location = locations && locations[i] ? locations[i] : null;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_USERS_STATIC_SUCCESS,
        payload: arr
      })
    } else {
      dispatch({
        type: FETCH_ALL_USERS_STATIC_FAILED,
        payload: "No users available."
      });
    }
  },{onlyOnce: true});
};

export const clearFetchDrivers = () => (dispatch) => {
  const {
    driversRef,
    allLocationsRef,
  } = firebase;
  off(driversRef);
  off(allLocationsRef);
}


export const fetchDrivers = (appType) => async(dispatch) => {

  const {
    driversRef,
    allLocationsRef,
    settingsRef,
  } = firebase;

  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();

  dispatch({
    type: FETCH_ALL_DRIVERS,
    payload: null
  });

  onValue(driversRef, snapshot => {
    if (snapshot.val()) {
      onValue(allLocationsRef, locres=>{
        const locations = locres.val();
          const data = snapshot.val();
          const arr = Object.keys(data)
          .filter(i => {
            const driver = data[i];
            const location = locations && locations[i];
            
            // FIXED: Add detailed logging for driver filtering
            // OPTIMIZED: Remove individual driver logging for performance
            
            // FIXED: Check all required conditions
            const isApproved = driver.approved === true;
            const isActive = driver.driverActiveStatus === true;
            const isAvailable = driver.queue === false; // FIXED: Check queue status
            const hasLocation = location && location.lat && location.lng;
            const hasLicense = (driver.licenseImage && settings.license_image_required) || !settings.license_image_required;
            const hasCar = (driver.carApproved && settings.carType_required) || !settings.carType_required;
            const hasTerm = (driver.term && settings.term_required) || !settings.term_required;
            
            const isEligible = isApproved && isActive && isAvailable && hasLocation && hasLicense && hasCar && hasTerm;
            
            // OPTIMIZED: Remove individual driver logging for performance
            
            return isEligible;
          })
          .map(i => {
            return {
              id: i,
              location: locations && locations[i] ? locations[i]:null,
              carType: data[i].carType ? data[i].carType : null,
              vehicleNumber:  data[i].vehicleNumber ? data[i].vehicleNumber : null,
              firstName: data[i].firstName,
              lastName: data[i].lastName,
              category: data[i].category ? data[i].category : null, // FIXED: Include category
              queue: data[i].queue // FIXED: Include queue status
            };
          });
          // OPTIMIZED: Summary logging for performance
          console.log(`📊 Driver filtering: ${arr.length}/${Object.keys(data).length} eligible drivers`);
          
          dispatch({
            type: FETCH_ALL_DRIVERS_SUCCESS,
            payload: arr
          });
      }, appType === 'app'? {onlyOnce: true}: null)
    } else {
      dispatch({
        type: FETCH_ALL_DRIVERS_FAILED,
        payload: "No users available."
      });
    }
  },appType === 'app'? {onlyOnce: true}: null);
};

export const fetchDriversGeoQuery = (drivers) => async(dispatch) => {
  dispatch({
    type: FETCH_ALL_DRIVERS_SUCCESS,
    payload: drivers
  });
};


export const addUser = (userdata) => async(dispatch) => {
  const {
    usersRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: userdata
  });

  const countries = store.getState().countrylistdata.countries;

  let countryDetail;
  for(let i=0;i<countries.length;i++){
    if(countries[i].country === userdata.country){
      countryDetail = countries[i]
      break;
    }
  }

  userdata['country']= countryDetail.country,
  userdata['country_code']= countryDetail.country_code,
  userdata['currency_code']= countryDetail.currency_code,
  userdata['swipe_symbol']= countryDetail.swipe_symbol,
  userdata['symbol']= countryDetail.symbol

  delete userdata.tableData;

  push(usersRef, userdata).then(() => {
    dispatch({
      type: EDIT_USER_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_USER_FAILED,
      payload: error
    });
  });
}

export const editUser = (id, user) => (dispatch) => {

  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: user
  });
  let editedUser = user;
  delete editedUser.id;
  delete editedUser.tableData;
  set(singleUserRef(id), editedUser);
}

export const updateUserField = (id, fieldData) => (dispatch) => {
  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: fieldData
  });
  
  // Use update to only update specific fields
  update(singleUserRef(id), fieldData);
}

export const updateUserCar = (id, data) => (dispatch) => {
  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: data  
  });
  update(singleUserRef(id),data);
}

export const updateLicenseImage = (uid, imageBlob, imageType) => async (dispatch) => {

  const {
    singleUserRef,
    driverDocsRef,
    driverDocsRefBack,
    verifyIdImageRef
  } = firebase;

  let profile = {};
  if(imageType === 'licenseImage'){
    await uploadBytesResumable(driverDocsRef(uid),imageBlob);
    let image = await getDownloadURL(driverDocsRef(uid));
    profile.licenseImage = image;
  }
  if(imageType === 'licenseImageBack'){
    await uploadBytesResumable(driverDocsRefBack(uid),imageBlob);
    let image1 = await getDownloadURL(driverDocsRefBack(uid));
    profile.licenseImageBack = image1;
  }
  if(imageType === 'verifyIdImage'){
    await uploadBytesResumable(verifyIdImageRef(uid),imageBlob);
    let image1 = await getDownloadURL(verifyIdImageRef(uid));
    profile.verifyIdImage = image1;
  }
  update(singleUserRef(uid),profile);
  dispatch({
    type: EDIT_USER,
    payload: uid
  });
};

export const deleteUser = (uid) => (dispatch) => {

  const {
    auth,
    walletHistoryRef,
    singleUserRef,
    userNotificationsRef,
    carsRef,
    carEditRef,
    userLocationRef,
    addressEditRef
  } = firebase;

  dispatch({
    type: DELETE_USER,
    payload: uid
  });

  if (auth.currentUser.uid === uid) {
    off(singleUserRef(uid));
    off(walletHistoryRef(uid));
    off(userNotificationsRef(uid));
    off(addressEditRef(uid));
    off(userLocationRef(uid));
  }

  onValue(singleUserRef(uid), userdata => {
    const profile = userdata.val();
    if(profile.usertype === 'driver'){
      onValue(carsRef(uid, profile.usertype), carssnapshot => {
        let cars = carssnapshot.val();
        if (cars) {
          const arr = Object.keys(cars);
          for(let i = 0; i < arr.length; i++){
            remove(carEditRef(arr[i]));
          }
        }
      });
    } 
    remove(walletHistoryRef(uid));
    remove(userNotificationsRef(uid));
    remove(addressEditRef(uid));
    remove(userLocationRef(uid));
    
    remove(singleUserRef(uid)).then(() => {
      if (auth.currentUser.uid === uid) {
        signOut(auth);
        dispatch({
          type: USER_DELETED,
          payload: null
        });
      } else {
        remove(singleUserRef(uid)).then(() => {
          dispatch({
            type: DELETE_USER_SUCCESS,
            payload: null
          });
        }).catch((error) => {
          dispatch({
            type: DELETE_USER_FAILED,
            payload: error
          });
        });
      }
    });
  },{onlyOnce:true});
}

// Bulk update category & carType for multiple drivers, and sync with active car
export const bulkUpdateDriversCategoryCarType = (driverIds, category, carType) => async (dispatch) => {
  const { singleUserRef, carsRef, carEditRef } = firebase;
  const updatePayload = { updateAt: Date.now() };
  if (category !== undefined && category !== null) updatePayload.category = category;
  if (carType !== undefined && carType !== null) updatePayload.carType = carType;

  for (const uid of driverIds) {
    try {
      // Update user profile fields
      await update(singleUserRef(uid), updatePayload);

      // Find active car and update its category/carType
      const carQuery = carsRef(uid, 'driver');
      const snap = await get(carQuery);
      const cars = snap.val();
      if (cars) {
        for (const [carId, car] of Object.entries(cars)) {
          if (car && car.active) {
            const carUpdate = {};
            if (category !== undefined && category !== null) carUpdate.category = category;
            if (carType !== undefined && carType !== null) carUpdate.carType = carType;
            await update(carEditRef(carId), carUpdate);
            break; // Only update the active car
          }
        }
      }
    } catch (error) {
      console.error('Bulk update driver failed:', { uid, error });
    }
  }

  dispatch({
    type: EDIT_USER,
    payload: { method: 'BulkUpdateCategoryCarType', driverIds, category, carType }
  });
};
